const questionSetConfirmationTemplate = ({title, alertText, reviewText, confirmationText}) => `<div class="start-question-set-confirmation-container" role="alertdialog" aria-label="${title}" aria-describedby="questionSetConfirmationAlert">
   <p id="questionSetConfirmationAlert" class="sr-only alert-only">${alertText}</p>
   <button type="button" class="review-button button button-secondary fill-parent top-button-element button-taller" data-cy="review-quiz-button">${reviewText}</button>
   <button type="button" class="confirm-button button button-primary fill-parent button-taller" data-cy="confirm-quiz-button">${confirmationText}</button>
   <div class="chat-bubble-arrow"></div>
</div>`;

export default questionSetConfirmationTemplate;
